import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  register(data) {
    return this.http.post(this.baseUrl + 'user/registration', data);
  }

  sendOtp(phoneNumber) {
    return this.http.post(this.baseUrl + 'user/registration/send-otp', { phoneNumber });
  }

  verifyOtp(activationCode) {
    return this.http.post(this.baseUrl + 'user/registration/verify-otp', { activationCode });
  }

  saveMarketingInfo(data) {
    return this.http.post(this.baseUrl + 'user/registration/marketing-info', data);
  }
}
